/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the RptSalPlannedFilterDto interface.
 */
export function instanceOfRptSalPlannedFilterDto(value) {
    return true;
}
export function RptSalPlannedFilterDtoFromJSON(json) {
    return RptSalPlannedFilterDtoFromJSONTyped(json, false);
}
export function RptSalPlannedFilterDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'dataInvioSalStart': json['dataInvioSalStart'] == null ? undefined : (new Date(json['dataInvioSalStart'])),
        'dateInvioSalEnd': json['dateInvioSalEnd'] == null ? undefined : (new Date(json['dateInvioSalEnd'])),
        'pkTipologiaBlocco': json['pkTipologiaBlocco'] == null ? undefined : json['pkTipologiaBlocco'],
        'plUserId': json['plUserId'] == null ? undefined : json['plUserId'],
        'plV2UserId': json['plV2UserId'] == null ? undefined : json['plV2UserId'],
        'idStrutturaBusiness': json['idStrutturaBusiness'] == null ? undefined : json['idStrutturaBusiness'],
        'idCliente': json['idCliente'] == null ? undefined : json['idCliente'],
        'page': json['page'] == null ? undefined : json['page'],
        'size': json['size'] == null ? undefined : json['size'],
        'caricaTotali': json['caricaTotali'] == null ? undefined : json['caricaTotali'],
    };
}
export function RptSalPlannedFilterDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'dataInvioSalStart': value['dataInvioSalStart'] == null ? undefined : ((value['dataInvioSalStart']).toISOString().substring(0, 10)),
        'dateInvioSalEnd': value['dateInvioSalEnd'] == null ? undefined : ((value['dateInvioSalEnd']).toISOString().substring(0, 10)),
        'pkTipologiaBlocco': value['pkTipologiaBlocco'],
        'plUserId': value['plUserId'],
        'plV2UserId': value['plV2UserId'],
        'idStrutturaBusiness': value['idStrutturaBusiness'],
        'idCliente': value['idCliente'],
        'page': value['page'],
        'size': value['size'],
        'caricaTotali': value['caricaTotali'],
    };
}
